/* eslint jsx-a11y/anchor-is-valid: 0 */
import Moment from 'react-moment';
import React from "react";
import { Link } from "react-router-dom";
import RowImages from "../components/common/RowImages";
import Actions from "../components/common/Actions";
import Chips from "../components/common/Chips";
import { MDBDataTable } from 'mdbreact';
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardFooter,
  Badge,
  Button
} from "shards-react";
import {firebases,files } from '../config';
import { ButtonGroup } from "shards-react";
import PageTitle from "../components/common/PageTitle";



const firebaseDb = firebases.database().ref().child('blogs');
let context = null;


const header = [
  {
    label: 'Image',
    field: 'blogImage',
    sort: 'asc',
    width: 115,
    type:"IMAGE"
  },
  {
    label: 'Title',
    field: 'title',
    sort: 'asc',
    width: 145
  },{
    label: 'Sub Title',
    field: 'subTitle',
    sort: 'asc',
    width: 150
  },
  {
    label: 'Read Time',
    field: 'readTime',
    sort: 'asc',
    width: 90
  },
  {
    label: 'Post By',
    field: 'postBy',
    sort: 'asc',
    width: 150
  },
  {
    label: 'Source',
    field: 'contentSource',
    sort: 'asc',
    width: 150
  },
  {
    label: 'Category/Tags',
    field: 'categories',
    sort: 'asc',
    width: 100,
    type:"CHIPS"
  },
  {
    label: 'Author',
    field: 'authorImage',
    sort: 'asc',
    width: 150,
    type:"IMAGE"
  },
  {
    label: 'Author Name',
    field: 'authorName',
    sort: 'asc',
    width: 150
  },
  
  {
    label: 'Actions',
    field: 'actions',
    sort: 'asc',
    width: 110,
    type:'ACTIONS'
  }
];


const baseName = "Blog";
class BlogPosts extends React.Component {
  constructor(props) {
    super(props);
    context = this;
    this.state = {
      // First list of posts.
      blogsList: [],
      isGridView:false
    };
  }

  componentDidMount(){

    this.getListFromDb();
  
  }
  
  
  getListFromDb(){
  
    firebaseDb.on('value', snap => {
      
      let dbList = [];
      let tableList = [];
      let sourceList = [];
      console.log(snap);
      snap.forEach(shot => {
  
        let row = {};
      header.forEach(function(prop){


        if(prop.type==="IMAGE"){
          row[prop.field] = <RowImages src={shot.val()[prop.field]}/>;
        }
        else if(prop.type==="ACTIONS"){
          row[prop.field] = <Actions id={shot.key} baseName={baseName} firebaseDb={firebaseDb} />;
        }
        else if(prop.type==="CHIPS"){
          row[prop.field] = <Chips chips={shot.val()[prop.field]} />;
        }
        else{
          row[prop.field] = shot.val()[prop.field];
        }


      });
  
        tableList.push(row);
        dbList.push({ ...shot.val(), key: shot.key });
        sourceList.push({ ...shot.val(), key: shot.key });
      });
  
  
      context.setState({blogsList: dbList.reverse(),tableList:tableList.reverse()}); 
      context.setState({sourceList: sourceList}); 
  
  
    });
  }
  

  toggleView = () =>{

        context.setState({isGridView:!context.state.isGridView});
      
  }

  
  
  render() {
    const {
      blogsList,
      tableList,
      isGridView
      
    } = this.state;

    return (
      <Container fluid className="main-content-container px-4">
        {/* Page Header */}
        <Row noGutters className="page-header py-4">
          <PageTitle sm="4" title="Blog Posts" subtitle="All Blogs" className="text-sm-left" 
          showAddNew={true} baseName={"Blog"} 
          showGridSwitch={true} toggleView={this.toggleView}/>
        </Row>
       {!isGridView ?  <Row>
      <Col>
        <Card small className="mb-4">
       {/*    <CardHeader className="border-bottom">
            <h6 className="m-0">Active Users</h6>
          </CardHeader> */}
          <CardBody className="p-3 pb-3">
          <MDBDataTable scrollY scrollX
          maxHeight="40vh"
      striped
      bordered
      hover
      data={{columns:header,rows:tableList}}
    />
          </CardBody>
        </Card>
      </Col>
    </Row> : 

        <Row>
          {blogsList.map((post, idx) => (
            <Col lg="3" md="6" sm="12" className="mb-4" key={idx}>
              <Card small className="card-post card-post--1">
              <Link to={'/blog-edit-view/'+post.key} className="text-fiord-blue">  <div
                  className="card-post__image"
                  style={{ backgroundImage: `url(${post.blogImage})` }}
                >
                  <Badge
                    pill
                    className={`card-post__category bg-${post.readTime}`}
                  >
                    {post.readTime} Minutes
                  </Badge>
                  
                  <div className="card-post__author d-flex">
                    <a
                      href="#"
                      className="card-post__author-avatar card-post__author-avatar--small"
                      style={{ backgroundImage: `url('${post.authorImage}')` }}
                    >
                      Written by {post.authorName}
                    </a>
                  </div>
                </div> </Link>
                <CardBody>
                  <h5 className="card-title">
                    <Link to={'/blog-edit-view/'+post.key} className="text-fiord-blue">
                      {post.title}
                    </Link>
                  </h5>
                
                  {post.categories!=undefined ? 
               <Chips chips={post.categories}/>
                : ''}
     
             
 


          <p><span className="text-muted" >
          <Moment format="ddd, DD-MMM-YYYY">{post.dateOfPublishing}</Moment></span>
          <br/><span className="text-muted" >
          Written by - {post.authorName}</span></p>

                </CardBody>
                
              </Card>
            </Col>
          ))}
        </Row>
       }
       
      </Container>
    );
  }
}

export default BlogPosts;
